<!--  -->
<template>
<div class="sendCode__button">
  <span
    v-if="sendStatus"
  >
    {{ `${count}s` }}
  </span>
  <span
    v-else
    @click="handleSend"
  >发送验证码</span>
</div>
</template>

<script>
import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { getPhoneCode } from '@/request/login';
import swal from '../utils/swal';

export default {
  props: {
    phone: {
      type: String,
    },
  },

  data() {
    return {
      sendStatus: false,
      count: 60,
    };
  },
  methods: {
    checkPhone(phone) {
      if (!phone) return false;
      if (!(/^1[3456789]\d{9}$/.test(phone))) {
        return false;
      }
      return true;
    },
    handleSend() {
      if (!this.checkPhone(this.phone)) {
        swal.error('请检查手机号');
      } else {
        this.sendStatus = true;
        this.handleGetPhoneCode();
      }
    },
    async handleGetPhoneCode() {
      const { phone } = this;
      const p1 = phone.substr(0, 3);
      const p2 = phone.substr(8);
      const t = dayjs().format('YYYYMMDDHHmm');
      const ticket = CryptoJS
        .MD5(`${p1}${p2}${t}`)
        .toString();
      try {
        const { status } = await getPhoneCode(
          { phone },
          { ticket },
        );
        if (status === 200) {
          this.getCode(60);
        }
      } catch (error) {
        console.log(error);
      }
      return '';
    },
    getCode(count) {
      if (count === 0) {
        this.sendStatus = false;
        this.count = 60;
        window.clearTimeout();
      } else {
        this.sendStatus = true;
        this.count -= 1;
        setTimeout(() => {
          this.getCode(this.count);
        }, 1000);
      }
    },
  },
};

</script>
<style lang='less' scoped>
@import url('../assets/styles/mixins.less');

.sendCode__button {
  width: 138px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  color:rgba(255,247,231,1);
  font-size: 16px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  user-select: none;
  cursor: pointer;
  span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .bg-img('../images/login/code__button_bg')
}
</style>
